import type { UserSavedAddress } from "@be-miniapp/api"

export const isJsonString = (str: any) => {
  try {
    JSON.parse(str)
  } catch (_e) {
    return false
  }
  return true
}

export const removePackageNameInRoute = (route: string) => {
  const routeArr = route.split("://")
  return `/${routeArr[routeArr.length - 1]}`
}

export const constructVehicleString = (
  brand: string | null | undefined,
  model: string | null | undefined,
  color: string | null | undefined
) => {
  if (!brand) return " "

  if (!model) {
    return brand ?? " "
  }

  if (!color) {
    return `${brand} | ${model}`
  }

  return `${brand} | ${model} | ${color}`
}

export const stripEmojis = (str: string) =>
  str
    .replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
      ""
    )
    .replace(/\s+/g, " ")
    .trim()

export const getSavedAddressName = (address: UserSavedAddress, t: any) => {
  if (address.type?.toLowerCase() === "home") {
    return t("location_home")
  } else if (address.type?.toLowerCase() === "work") {
    return t("location_work")
  }

  if (!address.type) {
    return address.address.split(",")[0]
  }

  return address.type
}
